import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const dayLabels = {
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun'
};

/**
 * Read-only display of the current run frequency schedule.
 * Shown on the Overview tab in place of the scheduling editor.
 */
const OverviewScheduleSummary = ({ schedulingMode, timeUnit, timeValue, schedules, onEditClick }) => {
  const getIntervalText = () => {
    if (!timeValue?.value) return 'Not configured';
    const unit = timeUnit === 'minute' ? 'minute' : 'hour';
    const val = timeValue.value;
    return `Every ${val} ${unit}${val > 1 ? 's' : ''}`;
  };

  const getCalendarText = () => {
    if (!schedules || schedules.length === 0) return 'Not configured';
    return schedules.map((schedule, i) => {
      const days = (schedule.days || []).map(d => dayLabels[d] || d).join(', ');
      const times = (schedule.times || []).join(', ');
      return `${days} at ${times} UTC`;
    });
  };

  const isConfigured =
    schedulingMode === 'interval' ? !!(timeUnit && timeValue?.value) : schedules && schedules.length > 0;

  return (
    <Card className="h-100">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h6 className="mb-0" style={{ fontWeight: 600 }}>
            Run Frequency
          </h6>
          {onEditClick && (
            <button
              className="btn btn-link btn-sm p-0 text-muted"
              onClick={onEditClick}
              style={{ textDecoration: 'none', fontSize: '0.8rem' }}
            >
              <FontAwesomeIcon icon="pencil-alt" className="me-1" />
              Edit
            </button>
          )}
        </div>

        {!isConfigured ? (
          <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
            <FontAwesomeIcon icon="clock" className="me-2 text-muted" />
            Schedule not configured
          </p>
        ) : schedulingMode === 'interval' ? (
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon="clock" className="me-2" style={{ color: '#253746' }} />
            <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>{getIntervalText()}</span>
          </div>
        ) : (
          <div className="d-flex align-items-start">
            <FontAwesomeIcon icon="calendar-alt" className="me-2 mt-1" style={{ color: '#253746' }} />
            <div>
              {getCalendarText().map((text, i) => (
                <div key={i} className={i > 0 ? 'mt-1' : ''}>
                  <span style={{ fontSize: '0.95rem', fontWeight: 500 }}>{text}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

OverviewScheduleSummary.propTypes = {
  schedulingMode: PropTypes.string,
  timeUnit: PropTypes.string,
  timeValue: PropTypes.object,
  schedules: PropTypes.array,
  onEditClick: PropTypes.func
};

export default OverviewScheduleSummary;
